import { Auth } from 'aws-amplify'
import { protectedApi } from '@/client/utils'
import { api } from '@/client/utils'
import { IPayment, IPaymentsDataQuery } from './types'

export const getUserInfos = async () => {
  const { attributes } = await Auth.currentAuthenticatedUser()
  const url = `/customers/${attributes['custom:customer_id']}`
  const { data } = await protectedApi.get(url)
  return data?.data
}

export const updateUserInfos = async (data) => {
  const { attributes } = await Auth.currentAuthenticatedUser()
  const url = `/customers/${attributes['custom:customer_id']}/updateCustomer`
  const apiUpdate = await protectedApi.post(url, JSON.stringify(data))
  const awsUpdate = await updateUserInfosAmplify(data)
  return { apiUpdate, awsUpdate }
}

export const updateUserInfosAmplify = async (data) => {
  const user = await Auth.currentAuthenticatedUser()
  const noUpdateNeeded = user.attributes.name === data.first_name && user.attributes.family_name === data.surname
  // Should we allow changing email?
  return (
    noUpdateNeeded ||
    (await Auth.updateUserAttributes(user, {
      name: data.first_name,
      family_name: data.surname
      // email: data.email
    }))
  )
}

export const getCustomerPaymentTypes = async (
  customerId: string,
  token: string,
  currency: string
): Promise<IPayment[]> => {
  const url = `/payments/${customerId}/types`
  const { data } = await api.get<IPaymentsDataQuery>(url, {
    params: {
      token: token,
      currency: currency
    }
  })
  return data?.payments
}

// Get Tax Exempt link from backend, later this URL will be used for avalara entry.
// Most of the works are happening in backend.
export const getTaxExemptLink = async (customerId: string): Promise<any> => {
  const url = `customers/${customerId}/certExemptLink`
  const { data } = await protectedApi.get<IPaymentsDataQuery>(url)
  return data
}
